/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Buttons
import Primary from './buttons/primary'
import Secondary from './buttons/secondary'
import Container from './container'

const CTO = () => {
    return (
        <section className="cto bg-primary-light py-28">
            <Container>
                <div className="header text-center mb-12">
                    <h1 className="text-lg text-purple-500 font-semibold uppercase mb-1">Get Started</h1>
                    <h2 className="text-3xl text-gray-200 font-bold mb-6">Ready to get started?</h2>
                    <div className="flex flex-wrap items-center justify-center">
                        <div className="flex justify-center w-1/2 sm:w-1/2 md:w-auto lg:w-auto items-center mr-0 sm:mr-0 md:mr-8 lg:mr-8 mb-2.5 sm:mb-2.5 md:mb-0 lg:mb-0">
                            <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </span>
                            <p className="text-gray-300 text-base ml-4">Full Control</p>
                        </div>
                        <div className="flex justify-center w-1/2 sm:w-1/2 md:w-auto lg:w-auto items-center mr-0 sm:mr-0 md:mr-8 lg:mr-8 mb-2.5 sm:mb-2.5 md:mb-0 lg:mb-0">
                            <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </span>
                            <p className="text-gray-300 text-base ml-4">Affordable</p>
                        </div>
                        <div className="flex justify-center w-1/2 sm:w-1/2 md:w-auto lg:w-auto items-center mr-0 sm:mr-0 md:mr-8 lg:mr-8">
                            <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </span>
                            <p className="text-gray-300 text-base ml-4">Premium Support</p>
                        </div>
                        <div className="flex justify-center w-1/2 sm:w-1/2 md:w-auto lg:w-auto items-center">
                            <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </span>
                            <p className="text-gray-300 text-base ml-4">Full Customization</p>
                        </div>
                    </div>
                </div>
                <div className="body">
                    <div className="buttons flex flex-wrap items-center justify-center">
                        <div className='w-full md:w-auto flex justify-center'>
                            <Primary link="/games/minecraft" route={true} rounded='sm' arrow={false} length='lg'>Get Started</Primary>
                        </div>
                        <div className="w-full md:w-auto mt-4 md:mt-0 ml-0 md:ml-8 flex justify-center">
                            <Secondary link="/games" route={true} rounded='sm' arrow={false} length='lg'>Learn More</Secondary>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default CTO